import { render, staticRenderFns } from "./SelfAssessmentEnter.vue?vue&type=template&id=9ac89c60&scoped=true"
import script from "./SelfAssessmentEnter.vue?vue&type=script&lang=js"
export * from "./SelfAssessmentEnter.vue?vue&type=script&lang=js"
import style0 from "./SelfAssessmentEnter.vue?vue&type=style&index=0&id=9ac89c60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ac89c60",
  null
  
)

export default component.exports